export default {
  data() {
    return {
      loading: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    actionCount: {
      default: 0,
    },
    selectedCount: {
      default: 0,
    },
    nodeIds: {
      default: () => [],
    },
    nodes: {
      default: () => [],
    },
  },
  methods: {
    hideModal() {
      this.$root.$emit('bv::hide::modal', this.modalId);
      this.$emit('hidden');
      this.loading = false;
    },
    hideEvents() {
      this.$emit('update:show');
      this.hideModalEvents();
    },
    // This should be implemented on each modal
    hideModalEvents() {},
  },
};
